import React, { Component } from "react";
import Section from "./components/Section";
import ItemButton from "./components/ItemButton";
import CartButton from "./components/cartButton";
import OrderSummary from "./components/orderSummary";

class App extends Component {
  state = {
    typeOfSpace: "Personal Indoor Space",
    widthOfSpace: 10,
    lengthOfSpace: 10,
    batteryTenderService: false,
    rvRefrigeratorPlugin: false,
    addonsEnabled: true,
    dropoffDate: "",
    indoorRecreationalPrice: 0.38,
    outdoorRecreationalPrice: 0.25,
    indoorPersonalStorage: 0.5,
    monthlyCost: 0,
    batteryAddonCost: 8,
    fridgeAddonCost: 40,
  };

  spaceTypeRef = React.createRef();
  widthRef = React.createRef();
  lengthRef = React.createRef();

  handleSelectSpaceType = event => {
    if(this.spaceTypeRef.current.value === "Personal Indoor Space") {
      this.setState({
        typeOfSpace: this.spaceTypeRef.current.value,
        widthOfSpace: 10,
        lengthOfSpace: 10,
      });
    }

    if(this.spaceTypeRef.current.value === "Indoor Recreational Space") {
      this.setState({
        typeOfSpace: this.spaceTypeRef.current.value,
        widthOfSpace: 12,
        lengthOfSpace: 12,
      });
    }

    if(this.spaceTypeRef.current.value === "Outdoor Recreational Space") {
      this.setState({
        typeOfSpace: this.spaceTypeRef.current.value,
        widthOfSpace: 14,
        lengthOfSpace: 15,
      });
    }
  };

  calculateMonthlyCost = () => {
    if (this.state.typeOfSpace === "Personal Indoor Space") {
      this.setState({
        monthlyCost:
          parseInt(this.widthRef.current.value * this.lengthRef.current.value) *
          this.state.indoorPersonalStorage,
      });
    }
    if (this.state.typeOfSpace === "Indoor Recreational Space") {
      this.setState({
        monthlyCost:
          parseInt(this.widthRef.current.value * this.lengthRef.current.value) *
          this.state.indoorRecreationalPrice,
      });
    }
    if (this.state.typeOfSpace === "Outdoor Recreational Space") {
      this.setState({
        monthlyCost:
          parseInt(this.widthRef.current.value * this.lengthRef.current.value) *
          this.state.outdoorRecreationalPrice,
      });
    }
  };

  componentDidMount() {
    return this.calculateMonthlyCost();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.widthOfSpace !== this.state.widthOfSpace) {
      return this.calculateMonthlyCost();
    }
    if (prevState.lengthOfSpace !== this.state.lengthOfSpace) {
      return this.calculateMonthlyCost();
    }
    if (prevState.typeOfSpace !== this.state.typeOfSpace) {
      return this.calculateMonthlyCost();
    }
  }

  handleWidthInputChange = event => {
    this.setState({ widthOfSpace: parseInt(this.widthRef.current.value) });
  };

  handleLengthInputChange = event => {
    this.setState({
      lengthOfSpace: parseInt(this.lengthRef.current.value),
    });
  };

  handleVehicleDimensions = event => {
    this.setState({
      widthOfSpace: 10,
      lengthOfSpace: 10,
    });
  };

  handleMotorcycleDimensions = event => {
    this.setState({
      widthOfSpace: 10,
      lengthOfSpace: 10,
    });
  };

  handleBoxesDimensions = event => {
    this.setState({
      widthOfSpace: 10,
      lengthOfSpace: 20,
    });
  };

  handleFurnitureDimensions = event => {
    this.setState({
      widthOfSpace: 20,
      lengthOfSpace: 40,
    });
  };

  handleLargeRVDimensions = event => {
    this.setState({
      widthOfSpace: 18,
      lengthOfSpace: 44,
    });
  };

  handleSmallRVDimensions = event => {
    this.setState({
      widthOfSpace: 12,
      lengthOfSpace: 20,
    });
  };

  handleMediumRVDimensions = event => {
    this.setState({
      widthOfSpace: 12,
      lengthOfSpace: 40,
    });
  };

  handleBatteryAddon = event => {
    this.setState({
      batteryTenderService: !this.state.batteryTenderService,
    });
  };

  handleFridgeAddon = event => {
    this.setState({
      rvRefrigeratorPlugin: !this.state.rvRefrigeratorPlugin,
    });
  };

  render() {
    let pricePerSquareFoot;
    let productID;
    let variationID;

    if (this.state.typeOfSpace === "Personal Indoor Space") {
      pricePerSquareFoot = this.state.indoorPersonalStorage;
      productID = 626;
      variationID = 631;
    }
    if (this.state.typeOfSpace === "Indoor Recreational Space") {
      pricePerSquareFoot = this.state.indoorRecreationalPrice;
      productID = 626;
      variationID = 632;
    }
    if (this.state.typeOfSpace === "Outdoor Recreational Space") {
      pricePerSquareFoot = this.state.outdoorRecreationalPrice;
      productID = 629;
      variationID = 630;
    }

    return (
      <div className="container mx-auto">
        <Section heading="What type of space are you looking for?">
          <select
            className="p-3 border-2 border-grey-darker w-96"
            name="spaceType"
            id="spaceType"
            onChange={this.handleSelectSpaceType}
            ref={this.spaceTypeRef}
          >
            <option value="Personal Indoor Space">
              Personal Indoor Storage Space
            </option>
            <option value="Indoor Recreational Space">
              Indoor Recreactional Storage
            </option>
            <option value="Outdoor Recreational Space">
              Outdoor Recreactional Storage
            </option>
          </select>
        </Section>
        {this.state.typeOfSpace === "Personal Indoor Space" && (
          <Section heading="What type of item are you storing?">
            <p className="text-sm text-grey-dark">
              Your selection will offer suggested dimensions for the space you
              would need for that particular type of item. However, the area
              needed for various items may vary so please be as accurate as
              possible.
            </p>
            <div className="flex flex-wrap justify-center mt-4">
              <ItemButton event={this.handleVehicleDimensions}>
                <i className="fas fa-car text-5xl" />
                <span className="uppercase font-bold mt-2">Vehicles</span>
              </ItemButton>
              <ItemButton event={this.handleMotorcycleDimensions}>
                <i className="fas fa-motorcycle text-5xl" />
                <span className="uppercase font-bold mt-2">Motorcycles</span>
              </ItemButton>
              <ItemButton event={this.handleBoxesDimensions}>
                <i className="fas fa-box-open text-5xl" />
                <span className="uppercase font-bold mt-2">Boxes</span>
              </ItemButton>
              <ItemButton event={this.handleFurnitureDimensions}>
                <i className="fas fa-couch text-5xl" />
                <span className="uppercase font-bold mt-2">Furniture</span>
              </ItemButton>
            </div>
          </Section>
        )}
        {this.state.typeOfSpace === "Indoor Recreational Space" && (
          <Section heading="What type of item are you storing?">
            <p className="text-sm text-grey-dark">
              Your selection will offer suggested dimensions for the space you
              would need for that particular type of item. However, the area
              needed for various items may vary so please be as accurate as
              possible.
            </p>
            <div className="flex flex-wrap justify-center mt-4">
              <ItemButton event={this.handleSmallRVDimensions}>
                <p>
                  <i className="fas fa-bus text-5xl" />
                  <i className="fas fa-ship text-5xl" />
                </p>
                <span className="uppercase font-bold mt-2">Small RV/Boat</span>
              </ItemButton>
              <ItemButton event={this.handleMediumRVDimensions}>
                <p>
                  <i className="fas fa-bus text-5xl" />
                  <i className="fas fa-ship text-5xl" />
                </p>
                <span className="uppercase font-bold mt-2">Medium RV/Boat</span>
              </ItemButton>
              <ItemButton event={this.handleLargeRVDimensions}>
                <p>
                  <i className="fas fa-bus text-5xl" />
                  <i className="fas fa-ship text-5xl" />
                </p>
                <span className="uppercase font-bold mt-2">Large RV/Boat</span>
              </ItemButton>
            </div>
          </Section>
        )}
        {this.state.typeOfSpace === "Outdoor Recreational Space" && (
          <Section heading="What type of item are you storing?">
            <p className="text-sm text-grey-dark">
              Your selection will offer suggested dimensions for the space you
              would need for that particular type of item. However, the area
              needed for various items may vary so please be as accurate as
              possible.
            </p>
            <div className="flex flex-wrap justify-center mt-4">
              <ItemButton event={this.handleSmallRVDimensions}>
                <p>
                  <i className="fas fa-bus text-5xl" />
                  <i className="fas fa-ship text-5xl" />
                </p>
                <span className="uppercase font-bold mt-2">Small RV/Boat</span>
              </ItemButton>
              <ItemButton event={this.handleMediumRVDimensions}>
                <p>
                  <i className="fas fa-bus text-5xl" />
                  <i className="fas fa-ship text-5xl" />
                </p>
                <span className="uppercase font-bold mt-2">Medium RV/Boat</span>
              </ItemButton>
              <ItemButton event={this.handleLargeRVDimensions}>
                <p>
                  <i className="fas fa-bus text-5xl" />
                  <i className="fas fa-ship text-5xl" />
                </p>
                <span className="uppercase font-bold mt-2">Large RV/Boat</span>
              </ItemButton>
            </div>
          </Section>
        )}
        <Section heading="How much space do you need?">
          <p className="text-sm text-grey-dark">
            Spaces are available from 1,00 square feet to 50,000 square feet.
          </p>
          <div className="mt-4">
            <input
              className="p-3 ml-4 border-2 border-grey-darker"
              type="number"
              name="spaceWidthInput"
              placeholder="Width"
              ref={this.widthRef}
              onChange={this.handleWidthInputChange}
              value={this.state.widthOfSpace}
            />
            <input
              className="p-3 ml-4 border-2 border-grey-darker"
              type="number"
              name="spaceLengthInput"
              placeholder="Length"
              ref={this.lengthRef}
              onChange={this.handleLengthInputChange}
              value={this.state.lengthOfSpace}
            />
          </div>
        </Section>
        <div className="p-4 border-2 border-grey-dark mt-6 mb-8 text-center rounded-lg bg-grey-light">
          <h3 className="uppercase">Order Summary</h3>
          <p className="clearfix border-b-2 border-grey mt-4 pb-2">
            <span className="float-left">Storage Space Area</span>
            <span className="float-right">
              {this.state.widthOfSpace * this.state.lengthOfSpace} sq ft
            </span>
          </p>
          <p className="clearfix border-b-2 border-grey mt-4 pb-2">
            <span className="float-left">
              Rental Cost <small>(per square foot)</small>
            </span>
            <span className="float-right">
              ${pricePerSquareFoot.toFixed(2)}
            </span>
          </p>
          <OrderSummary state={this.state} />
        </div>
        <div className="flex ">
          <a
            className="text-center no-underline mx-auto bg-blue hover:bg-blue-light text-white font-bold py-4 px-5 border-b-4 border-blue-dark hover:border-blue rounded"
            href={`//risco-storage.com/addons/?add-to-cart=${productID}&variation_id=${variationID}&quantity=${this.state.widthOfSpace * this.state.lengthOfSpace}`}
          >
            <i className="fas fa-cart-plus" /> Add to Cart!
          </a>
        </div>
      </div>
    );
  }
}

export default App;
